'use strict';

// default house location keys, match babelfish source
exports.DEFAULT_HOUSE_LOCATION_KEYS = [
  'predefinedDeviceLocationFrontDoor',
  'predefinedDeviceLocationBackDoor',
  'predefinedDeviceLocationLivingRoom',
  'predefinedDeviceLocationBedroom1',
  'predefinedDeviceLocationBedroom2',
  'predefinedDeviceLocationKitchen',
  'predefinedDeviceLocationHallway',
  'predefinedDeviceLocationOffice',
  'predefinedDeviceLocationBackyard',
  'predefinedDeviceLocationBalcony',
];
